export default /*START_META*/{
  "title": "Things to setup in your website"
}; /*END_META*/